import React, { useState, useEffect } from 'react';
import { makeStyles, Divider, Typography, Button, Checkbox, FormControlLabel } from '@material-ui/core';
import MaterialCheckbox from '@mui/material/Checkbox';
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Drawer from '@material-ui/core/Drawer';
import clsx from 'clsx';
import { addEditDrawerWidth } from '../../config/constants';
import CloseIcon from '@mui/icons-material/Close';
import { dataService } from '../../services/data/data.service';
import { toDateFormatWithoutT } from '../../utils/dateHelper';
import { teal } from '@mui/material/colors';
import Form from 'react-bootstrap/Form'
import 'bootstrap/dist/css/bootstrap.css';




export default function CrudAddEditDrawer(props) {
    var now = new Date();
    const classes = useStyles();
    const [addeditObject, setAddeditObject] = useState({});
    const [validationObject, setValidationObject] = useState({})
    const [saveAttempt, setSaveAttempt] = useState(false)
    const [today, setToday] = useState(formatDate(now));
    const [collectionMethodCommentRequired, setCollectionMethodCommentRequired] = useState(false);
    const [addAnother, setAddAnother] = useState(false);
    const [toBeSaved, setObjectToSave] = useState({});


    useEffect(() => {
        if (props.editId !== null) {
            let editObject = props.rows.find(r => r.id === props.editId);
            if (JSON.stringify(addeditObject) === JSON.stringify({})) {
                setAddeditObject(editObject);
            }
        } else {
            if (JSON.stringify(addeditObject) !== JSON.stringify({})) {
            }
        }// eslint-disable-next-line
    }, [addeditObject, props.editId, props.rows]);

    //SC - 13/04/2022 - Material-UI uses inputProps(min and max) to disabled all dates before and after. This is done with a date string format yyyy-mm-dd
    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }
    const collectionMethods = props.foreignObjects.collectionMethodId;

    const fieldChanged = (column, value) => {
        let obj = { ...addeditObject };
        obj[column] = value;
        setAddeditObject(obj);
        validateFields(obj);

    }

    const handleAddEdit = (row, title) => {
        setSaveAttempt(true);
        if (validateFields(row)) {
            var collectionMethod = {};
            collectionMethods.map((x) => {
                if (x.id === parseInt(row.collectionMethodId)) {
                    collectionMethod = x;
                }
            });
            let edit = false;
            if (title === "Aanpassen") {
                edit = true;
            }
            var existingWithParameters = props.rows.find(x => x.collectionMethodName === collectionMethod.name && x.originId === parseInt(row.originId) && x.periodUnit === row.periodUnit && x.destinationId === parseInt(row.destinationId) && (x.periodValue).split('T')[0] === row.periodValue);
            let identificationCode = makeRegistration(36)

            let objectToSave = {
                IdentificationCode: identificationCode,
                CollectionMethodId: parseInt(row.collectionMethodId),
                CollectionMethodComment: row.collectionMethodComment,
                OriginId: parseInt(row.originId),
                DestinationId: parseInt(row.destinationId),
                MaterialId: parseInt(row.materialId),
                Quantity: parseFloat(row.strQuantity),
                UnitOfMeasurementId: parseInt(row.unitOfMeasurementId),
                PeriodValue: row.periodValue,
                PeriodUnit: row.periodUnit,
                Price: parseFloat(row.strPrice)
            }

            if (edit) {
                objectToSave.MomentInsert = row.momentInsert;
                objectToSave.UserIdInsert = parseInt(row.userIdInsert);
                objectToSave.UserIdUpdate = parseInt(props.user.userid);
                objectToSave.Id = row.id;
                objectToSave.Edit = edit;
            }
            else {
                objectToSave.Id = 0;
                objectToSave.UserIdInsert = parseInt(props.user.userid);
                objectToSave.Edit = edit;
            }

            if (existingWithParameters !== undefined && edit === false) {
                props.setOpenAlreadyExistsDialog(true);
                props.setExistingRegistration(existingWithParameters);
                props.setObjectToSave(objectToSave);
                handleClearFields();
                props.openDrawer("", false, null)

                setObjectToSave(objectToSave);
            } else {
                if (edit && row.sentToMatis !== '0001-01-01T00:00:00') {
                    //SC: The to be editted record was already sent to MATIS --> Get The pop-up to ask if the user is sure about his/her actions
                    setObjectToSave(objectToSave);
                    props.setObjectToSave(objectToSave);
                    props.setRegistrationAlreadySent(true);
                } else {
                    //SC: Not SentToMatis so just save it
                    setObjectToSave(objectToSave);
                    dataService.saveRegistration(objectToSave).catch((error) => {
                        console.log("failed editing registration row");
                    });
                    handleClearFields();

                    if (addAnother === false) {
                        //SC: The create another option has been activated so keep open the drawer and empty all fields so the user can easily create a new registration
                        props.openDrawer("", false, null)
                    }
                }
                props.setReload(true);
                setValidationObject({});
                setSaveAttempt(false);
            }

        }
    };

    const handleAddAnother = (event) => {
        setAddAnother(event.target.checked);
    }

    function makeRegistration(length) {
        var result = '';
        var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            if (i === 9 || i === 14 || i === 18 || i === 22) {
                result += '-';
            }
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
    const validateFields = (row) => {
        let tempValidationObject = { ...validationObject }
        let validationOK = true;

        props.columns.filter(x => x.editable === "True").forEach(x => {
            if (!row[x.name]) {
                validationOK = false;
                if (tempValidationObject[x.name] === false) {
                    tempValidationObject[x.name] = false;
                } else {
                    tempValidationObject[x.name] = true;


                }
            } else {
                tempValidationObject[x.name] = false;
            }
        })

        if (row.hasOwnProperty('quantity') && row.quantity < 0) {
            validationOK = false;
            tempValidationObject['quantity'] = true;

        }
        if (row.hasOwnProperty('price') && row.price < 0) {
            validationOK = false;
            tempValidationObject['price'] = true;

        }
        if (row.hasOwnProperty('collectionMethodId') && Object.values(row)[0] !== 9) {
            validationOK = true;
            tempValidationObject['collectionMethodComment'] = false;
        }
        let values = Object.values(tempValidationObject);
        validationOK = values.every(objet => objet === false);
        setValidationObject(tempValidationObject);
        return validationOK;
    }

    const validateField = (columnName) => {
        if (validationObject[columnName] && saveAttempt) {
            return 1;
        } else {
            return 0;
        }
    }

    const getForeignKeyRecordValue = (record) => {
        if (record["materialDescription"] !== undefined) {
            return record["materialDescription"];
        }

        if (record["name"] !== undefined) {
            return record["name"];
        }

        if (record["descriptioon"] !== undefined) {
            return record["name"];
        }

        if (record["code"] !== undefined) {
            return record["name"];
        }

        if (record["status"] !== undefined) {
            return record["name"];
        }
        return record;
    }

    const closeDrawer = () => {
        setSaveAttempt(false);
        setValidationObject({});
        setAddeditObject({});
        props.openDrawer("", false, null);
    }

    const handleClearFields = () => {
        setSaveAttempt(false);
        setValidationObject({});
        setAddeditObject({});
        let objectToSave = {
            collectionMethodComment: "",
            destinationId: null,
            materialId: null,
            originId: null,
            periodUnit: "",
            quantity: "",
            price: "",

            unitOfMeasurementId: null,
        }

        props.columns.map((column, index) => (
            ((document.getElementById(column.name) !== null) ? document.getElementById(column.name).value = '' : '')
            //            fieldChanged(column.name, null)
        ))


        setAddeditObject(objectToSave);

    }
    const GetEditorForDataType = (column) => {
        let isTooMuchInfo = false;
        if (props.foreignObjects[column.name] !== undefined) {
            if (props.foreignObjects[column.name].length >= 60) {
                isTooMuchInfo = true;
            }
        }

        let addEdit = addeditObject;
        if (column.editable === "False") {
            return <React.Fragment key={column.name}></React.Fragment>
        }

        if (column.isPrimaryKey === "True") {
            return <React.Fragment key={column.name}></React.Fragment>
        }

        if (column.isForeignKey === "True" && !isTooMuchInfo) {
            return <React.Fragment key={column.name}>
                <div className={classes.selectFragment}>
                    {/* <InputLabel style={{ color: validateField(column.name) ? "red" : "grey" }}>{column.name}</InputLabel> */}
                    <FloatingLabel controlId="floatingSelect" label={(column.title) + '*'} style={{ color: validateField(column.name) ? "red" : "grey" }}>
                        <Form.Select aria-label={column.title} aria-describedby={(column.title) + "Text"} value={addEdit[column.name]} className={classes.selectForm} id={generatedControlId} error={validateField(column.name)} onChange={(e) => fieldChanged(column.name, e.target.value)} >
                            <option value='' className={classes.optionForm} key='optionForm' ></option>
                            {
                                (props.foreignObjects[column.name] !== undefined && props.foreignObjects[column.name] !== null) ? props.foreignObjects[column.name].map((record, index) => (
                                    <option className={classes.optionForm} key={'key_' + record.id + '_' + index} value={record.id ? record.id : record}>
                                        {getForeignKeyRecordValue(record).length > 35 ? getForeignKeyRecordValue(record).substring(0, 35) + '...' : getForeignKeyRecordValue(record)}</option>
                                )) :
                                    <option key='key_empty'></option>
                            }
                        </Form.Select>
                    </FloatingLabel>
                    <div>
                        <Form.Text id={column.name + "Text"} style={{ color: "red", height: '10px', fontSize: '10px', paddingLeft: '5px', paddingTop: '0px' }}>
                            {validateField(column.name) ? column.title + ' ' + "verplicht" : ""}
                        </Form.Text>
                    </div>


                    {/*  <FormHelperText>  Verplicht*/}


                </div>

            </React.Fragment>
        }

        var generatedControlId = column.name + '_' + randomNumber();

        switch (column.dataType) {
                case 'bit':
                    return <FormControlLabel key={generatedControlId} value="end" control={<Checkbox error={validateField(column.name)} helpertext={validateField(column.name) ? (column.title) + ' ' + "verplicht" : ""} color="primary" defaultChecked={addEdit[column.name]} onChange={(e) => fieldChanged(column.name, e.target.checked)} className={classes.field} key={column.name} label={column.title} />}
                        label={column.title}
                        labelPlacement="end"
                    />
                case 'dateTimeWithT':
                    return <div className={classes.selectFragment} key={column.title}>
                        <FloatingLabel label={(column.title) + '*'} style={{ color: validateField(column.name) ? "red" : "grey" }}>
                            <Form.Control id={generatedControlId} value={addEdit[column.name] !== undefined ? toDateFormatWithoutT(addEdit[column.name]) : ''} inputprops={{ max: today }} type="date" error={validateField(column.name)} helpertext={validateField(column.name) ? (column.title) + ' ' + "verplicht" : ""} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.title} />
                            <Form.Text id={(generatedControlId) + "Text"} style={{ color: "red", height: '10px', fontSize: '10px', paddingLeft: '5px', paddingTop: '0px' }}>
                                {validateField(column.name) ? (column.title) + ' ' + "verplicht" : ""}
                            </Form.Text>
                        </FloatingLabel>
                    </div>

                case 'numeric':
                    return <div className={classes.selectFragment} key={column.title}>
                        <FloatingLabel label={(column.title) + '*'} style={{ color: validateField(column.name) ? "red" : "grey" }}>
                            <Form.Control id={generatedControlId} type="number" value={addEdit[column.name] !== undefined ? parseFloat(addEdit[column.name]) : 0} error={validateField(column.name)} helpertext={validateField(column.name) ? (column.title) + ' ' + "verplicht" : ""} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.title} />
                            <Form.Text id={(generatedControlId) + "Text"} style={{ color: "red", height: '10px', fontSize: '10px', paddingLeft: '5px', paddingTop: '0px' }}>
                                {validateField(column.name) ? (column.title) + ' ' + "verplicht" : ""}
                            </Form.Text>
                        </FloatingLabel>
                    </div>

                case 'collectionMethodComment':
                    return <div className={classes.selectFragment} key={column.title}>
                        <FloatingLabel label={column.title} >
                            <Form.Control id={generatedControlId} type="text" value={addEdit[column.name] !== undefined ? addEdit[column.name] : ''} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.title} />
                            <Form.Text id={(generatedControlId) + "Text"} style={{ color: "red", height: '10px', fontSize: '10px', paddingLeft: '5px', paddingTop: '0px' }}>
                            </Form.Text>
                        </FloatingLabel>
                    </div>
                default:
                    return <React.Fragment></React.Fragment>
            }
        

    }
    function randomNumber() {
        // 👇️ get number between min (inclusive) and max (inclusive)
        return Math.floor(Math.random() * (1000000000 - 0 + 1)) + 0;
    }
    const label = { inputprops: { 'aria-label': 'Maak nog een registratie' } };


    return <Drawer variant="temporary" className={clsx(classes.drawer, { [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, })} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} anchor='right' open={props.drawerOpen} onClose={() => closeDrawer()}>
        <div className={classes.closeButtonDiv}>
            <Typography className={classes.headerTitle}>{props.title}</Typography>
            <Button className={classes.closeButton} onClick={() => props.openDrawer("", false, null)}><CloseIcon></CloseIcon></Button>
        </div>
        <Divider />
        <div className={classes.drawerBody}>
            <form id="create-form">
                {props.columns.map((column, index) => (
                    GetEditorForDataType(column)
                ))}
            </form>
        </div>

        <FormControlLabel control={
            <MaterialCheckbox onChange={handleAddAnother} sx={{
                color: teal[800],
                '&.Mui-checked': {
                    color: teal[500],
                },
            }} />
        } label={'Maak nog een registratie'} />

        <Button className={classes.saveButton} onClick={() => handleAddEdit(addeditObject, props.title)} variant="contained">{"Opslaan"}</Button>
    </Drawer>
}

const useStyles = makeStyles((theme) => ({
    spacer80: {
        height: '80px'
    },


    paper: {
        padding: '50px',
        margin: "50px",
        height: '70%'
    },

    crudDrawer: {
        width: 250,
    },

    drawer: {
        width: addEditDrawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        padding: '20px'
    },
    optionForm: {
        height: '20px'
    },
    drawerOpen: {
        width: addEditDrawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        padding: '20px'
    },

    drawerClose: {
        width: 0,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden'
    },

    field: {
        display: "block !important"
    },

    saveButton: {
        backgroundColor: '#1F8FA5',
        color: "white",
        marginTop: "20px"
    },

    drawerBody: {
        marginTop: '10px',
        display: "block !important"
    },

    headerTitle: {
        fontSize: '22pt'
    },
    closeButtonDiv: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '5px'

    },

    selectFragment: {
        position: 'relative'
    }
}));